"use strict";

define('rs/form/formobjects/datepicker/datepicker.formobject.view',['require','exports','module','rs/form/formobjects/base.formobject.view','bootstrap-datepicker','backbone.radio','jquery','moment','bootstrap.datepicker.locales','language/support/supplemental.bootstrap.locales'],function (require, exports, module) {
  var BaseFormObjectView = require('rs/form/formobjects/base.formobject.view');
  var datepicker = require('bootstrap-datepicker');
  var Radio = require('backbone.radio');
  var $ = require('jquery');
  var moment = require('moment');
  var BOOTSTRAP_LOCALES = require('bootstrap.datepicker.locales');
  var SUPPLEMENTAL_LOCALES = require('language/support/supplemental.bootstrap.locales');
  var AppChannel = Radio.channel('global');
  var DatePickerView = BaseFormObjectView.extend({
    templates: {
      'datepicker.formobject': 'renderFormControls'
    },
    dateFormat: 'mm/dd/yyyy',
    events: {
      'blur >.form-object-contents input': 'handleTextboxBlur',
      'focus >.form-object-contents input': 'handleTextboxFocus',
      'click >.form-object-contents i': 'handleCalendarClick',
      'keydown >.form-object-contents input': 'handleTextboxKeydown',
      'keyup >.form-object-contents input': 'handleTextboxKeyup',
      'change >.form-object-contents input': 'handleTextboxChange'
    },
    initialize: function initialize() {
      BaseFormObjectView.prototype.initialize.apply(this, arguments);
      this.on('change:delegate', function () {
        this.setLocale();
      });
    },
    renderFormObjectControls: function renderFormObjectControls(templateProperties) {
      templateProperties.placeholder = this.dateFormat.toUpperCase();
      return this.renderFormControls(templateProperties);
    },
    getLocaleSupportPackage: function getLocaleSupportPackage(locale) {
      return BOOTSTRAP_LOCALES[locale] || SUPPLEMENTAL_LOCALES[locale];
    },
    isSupportedLocale: function isSupportedLocale(locale) {
      return !!this.getLocaleSupportPackage(locale);
    },
    setLocale: function setLocale() {
      var locale = AppChannel.request('get:moment:locale') || 'en';
      var localeSupportPackage;
      if (locale && locale !== 'en' && this.isSupportedLocale(locale)) {
        localeSupportPackage = this.getLocaleSupportPackage(locale);
        $.fn.datepicker.dates[locale] = localeSupportPackage;
        $.fn.datepicker.defaults.language = locale;
        if (localeSupportPackage.format) {
          this.dateFormat = localeSupportPackage.format;
        }
      }
    },
    setupFormElement: function setupFormElement() {
      var el = this.getContentElement(),
        fe = el.find('input');
      el.addClass('datepicker-form-object');
      this.setFormElement(fe);
      fe.datepicker({
        format: this.dateFormat
      }).on('changeDate', this.datePickerDateChange.proxy(this));
    },
    getValue: function getValue() {
      return this.getFormElement().val();
    },
    getDateFormatDividerCharacter: function getDateFormatDividerCharacter() {
      var dividerRegex = /^[\w]+([./-])/g;
      var dateDivider = dividerRegex.exec(this.dateFormat)[1];
      return dateDivider;
    },
    getYearFormatPositionIndex: function getYearFormatPositionIndex() {
      var dateDivider = this.getDateFormatDividerCharacter();
      return this.dateFormat.split(dateDivider).findIndex(function (item) {
        return item.indexOf('y') !== -1;
      });
    },
    handleTextboxKeydown: function handleTextboxKeydown(ev) {
      var delegate = this.getDelegate();
      var $datePickerInput = this.getContentElement().find('input');
      var dateDivider = this.getDateFormatDividerCharacter();
      var incomingCharacter = parseInt(ev.key) >= 0 && parseInt(ev.key) <= 9 ? ev.key : '';
      var yearPositionIndex = this.getYearFormatPositionIndex();
      var currentValueDateArray = delegate.getValue().split(dateDivider);
      var currentValueYear = currentValueDateArray[yearPositionIndex];
      var currentYearPrefix = String(moment().year()).substr(0, 2);
      if (typeof this.timeoutId === 'number') {
        clearTimeout(this.timeoutId);
      }
      if (yearPositionIndex !== 2 || ev.key === 'Backspace') {
        return;
      }
      if (currentValueYear && currentValueYear.length === 1 && incomingCharacter.length === 1) {
        this.timeoutId = setTimeout(function () {
          ev.preventDefault();
          currentValueDateArray[yearPositionIndex] = currentYearPrefix + currentValueYear + incomingCharacter;
          $datePickerInput.datepicker('update', currentValueDateArray.join(dateDivider));
          delegate.setValue(currentValueDateArray.join(dateDivider));
        }, 500);
      }
      if (ev.key === 'Enter') {
        $datePickerInput.datepicker('update', currentValueDateArray.join(dateDivider));
      }
    },
    handleCalendarClick: function handleCalendarClick(ev) {
      this.getFormElement().focus();
    },
    datePickerDateChange: function datePickerDateChange() {
      this.getDelegate().requestValueChange();
    },
    handleTextboxBlur: function handleTextboxBlur(ev) {
      this.getDelegate().requestValueChange();
    },
    handleTextboxFocus: function handleTextboxFocus(ev) {
      this.getDelegate().testSet().ignore();
    },
    handleTextboxKeyup: function handleTextboxKeyup(ev) {
      this.getAriaLabelDatePicker(ev);
    },
    handleTextboxChange: function handleTextboxChange(ev) {
      this.getAriaLabelDatePicker(ev);
    },
    getAriaLabelDatePicker: function getAriaLabelDatePicker(ev) {
      if (!ev.target.value) {
        $(ev.target).attr("aria-label", "date format: month, date, year. ");
      } else {
        var dateTimeFormatter = new Intl.DateTimeFormat("en-US", {
          dateStyle: 'long'
        });
        var formattedDate = dateTimeFormatter.format(new Date(ev.target.value));
        $(ev.target).attr("aria-label", "date: " + formattedDate);
      }
    }
  });
  module.exports = DatePickerView;
});

